/**
 * Account page module
 *
 * @module views/pages/account-page
 */
define('views/pages/requests/table-row',['require','jquery','underscore','views/base/view','lib/utils','text!templates/pages/requests/table-row.ejs'],function(require) {
    'use strict';

    var $ = require('jquery'),
        _ = require('underscore'),
        View = require('views/base/view'),
        utils = require('lib/utils'),
        template = require('text!templates/pages/requests/table-row.ejs');

    var TableRowView = View.extend({
        template: template,
        tagName: 'tr',
        listen: {
            'change:selected model': 'render'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
            this.delegate('click', '.icon-comment', this.clickComment);
            this.delegate('click', this.clickRow);
        },
        clickRow: function() {
            var item = this.model.collection.findWhere({ selected: true });
            if (item && item !== this.model) {
                item.set('selected', false);
            }
            this.model.set('selected', true);

            if (this.doShowComment) {
                utils.popover(this.$('.icon-comment'), 'Комментарий', this.model.get('Comment'));
                this.doShowComment = false;
            }

        },
        clickComment: function() {
            this.doShowComment = true;
        },
        render: function() {
            this.$('.icon-comment').popover('destroy');
            View.prototype.render.apply(this, arguments);
            if (this.model.get('selected')) {
                this.$el.addClass('active');
            } else {
                this.$el.removeClass('active');
            }
        },
        dispose: function() {
            if (this.disposed) {
                return;
            }

            this.$('.icon-comment').popover('destroy');

            View.prototype.dispose.apply(this, arguments);
        }
    });

    return TableRowView;
});

